module.exports = __webpack_public_path__ + "img/pdf-preview-empty.12b1dfe9.png";